import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import MaterialsRevisoesAcoes from './MaterialsRevisoesAcoes';

class MaterialsRevisoesTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      dados: [],
    };
    this.botaoAcoes = this.botaoAcoes.bind(this);
    this.refreshTable = this.refreshTable.bind(this);
    this.botaoDownloadArquivo = this.botaoDownloadArquivo.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.revisoes) && this.state.loaded === 0) {
      this.setState({dados: newProps.revisoes});
      this.setState({loaded: 1});
    }
  }

  refreshTable(event) {
    var header = this.refs.request_api.header('application/json');
    var self = this;
    var url = config.get('api') + '/material/revisoes/'+self.props.material_id;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
          self.props.handleAlert(event.message, event.status, 'open');
        }
      });
    });
  }

  botaoAcoes (cell, row) {
    var dados = this.state.dados;
    var status = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        if (dado.status === "aberta") {
          status = "aberta";
        } else if (dado.status === "aprovada") {
          status = "aprovada";
        } else if (dado.status === "superada") {
          status = "superada";
        }
      }
    });
    return (
      <MaterialsRevisoesAcoes handleAlert={this.props.handleAlert} status={status} refreshTable={this.refreshTable} material_revision_id={cell} material_id={this.props.material_id} />
    );
  }

  botaoDownloadArquivo (cell, row) {
    var dados = this.state.dados;
    var status = '';
    var arquivo = '';
    dados.map(function(dado, index){
      if (dado.id == cell) {
        arquivo = dado.archive;
      }
    });
    if (arquivo == '') {
      return (
        <div></div>
      );
    } else {
      return (
        <a target="_blank" href={config.get('cdn') + '/materiais/' + arquivo}> Download arquivo</a>
      );      
    }
  }

  deletar (event) {
    var team_training_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa treinamento?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/turma/treinamento/' + team_training_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(team_training_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Revisões</h3>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há revisões cadastradas'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Revisão</TableHeaderColumn>

    <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='100'>Status</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='350' dataFormat={this.botaoDownloadArquivo}>Arquivo</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoAcoes}>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default MaterialsRevisoesTab;



// WEBPACK FOOTER //
// ./src/Components/Materials/Elements/MaterialsRevisoesTab.js